<template>
  <Popover class="ts-popover" popper-class="ts-popover-popper" v-bind="$attrs" v-on="$listeners">
    <template #reference>
      <slot name="reference"></slot>
    </template>
    <div v-if="hasHeader" class="header">
      <slot name="header"></slot>
    </div>
    <slot></slot>
    <div v-if="hasFooter" class="footer">
      <slot name="footer"></slot>
    </div>
  </Popover>
</template>

<style lang="scss">
.ts-popover-popper {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
  border-radius: 13px;

  box-sizing: border-box;
  padding: 0;

  min-width: 20px;

  .popper__arrow {
    &::after {
      border-color: transparent !important;
    }
  }

  .footer {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.16);
    box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);
    border-radius: 0 0 13px 13px;

    margin: -2px;
    min-height: 42px;

    display: flex;
  }
}
</style>

<script>
import { Popover } from 'element-ui';

export default {
  name: 'TsPopover',
  components: {
    Popover
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header;
    },
    hasFooter() {
      return !!this.$slots.footer;
    }
  }
};
</script>
